module.exports = __webpack_public_path__ + "img/Bingo_Info_Game3.5e2ec3e3.png";